import axios from './axios';

/**
 * Resolves true if the current user is logged in. False otherwise.
 */
export default async function isLoggedIn(): Promise<boolean> {
  const response = await axios.get('/is-logged-in');
  return response.data.isLoggedIn;
}
